import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Features from "@/pages/features/page";
import Ranking from "@/pages/ranking/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "features", element: <Features /> },
      { path: "ranking", element: <Ranking /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;